import { Radar, Loader2, ShieldCheck } from "lucide-react";

/**
 * "Live Shodan lookup" card. Purely presentational — parent owns the result state.
 */
export function ClientShodanCard({ result, busy }) {
  return (
    <section className="border border-border bg-card/60 p-5 space-y-4">
      <div className="flex items-center gap-2">
        <Radar className="w-4 h-4 text-primary" />
        <div>
          <div className="overline">Escaneo de puertos Shodan</div>
          <h2 className="font-display text-lg font-medium mt-1">Consulta en vivo</h2>
        </div>
      </div>
      {busy ? (
        <div className="text-xs text-muted-foreground font-mono flex items-center gap-2">
          <Loader2 className="w-3 h-3 animate-spin" /> Consultando Shodan...
        </div>
      ) : result ? (
        <ShodanResult r={result} />
      ) : (
        <div className="text-xs text-muted-foreground border border-dashed border-border p-4">
          Haz clic en <span className="text-primary font-mono">Consulta Shodan</span> junto a cualquier IP para consultar puertos abiertos.
          <div className="mt-2 font-mono text-[10px] tracking-wide uppercase text-muted-foreground/70">
            Requiere API key configurada en Configuración → Integraciones.
          </div>
        </div>
      )}
    </section>
  );
}

function ShodanResult({ r }) {
  return (
    <div className="space-y-3">
      <div className="font-mono text-xs">
        <div className="flex justify-between"><span className="text-muted-foreground">IP</span><span>{r.ip}</span></div>
        {r.org && <div className="flex justify-between"><span className="text-muted-foreground">Org</span><span>{r.org}</span></div>}
        {r.isp && <div className="flex justify-between"><span className="text-muted-foreground">ISP</span><span>{r.isp}</span></div>}
        {r.country && <div className="flex justify-between"><span className="text-muted-foreground">Country</span><span>{r.country}</span></div>}
        <div className="flex justify-between mt-2">
          <span className="text-muted-foreground">Source</span>
          <span className={r.source === "stub" ? "text-sev-medium" : "text-sev-low"}>{r.source}</span>
        </div>
      </div>
      {r.ports?.length > 0 && (
        <div>
          <div className="overline mb-2">Puertos abiertos</div>
          <div className="flex flex-wrap gap-1">
            {r.ports.map((p) => (
              <span key={p} className="font-mono text-xs border border-sev-high text-sev-high px-1.5 py-0.5">{p}</span>
            ))}
          </div>
        </div>
      )}
      {r.services?.length > 0 && (
        <div>
          <div className="overline mb-2">Servicios</div>
          <div className="space-y-1">
            {r.services.slice(0, 6).map((s) => (
              <div key={`${s.port}-${s.protocol}-${s.product || ""}`} className="font-mono text-[11px] border-b border-border/50 pb-1">
                <span className="text-sev-high">{s.port}/{s.protocol}</span>
                {s.product && <span className="text-muted-foreground ml-2">{s.product}</span>}
                {s.version && <span className="text-muted-foreground ml-1">v{s.version}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
      {r.vulns?.length > 0 && (
        <div>
          <div className="overline mb-2 text-sev-critical">Vulns</div>
          <div className="flex flex-wrap gap-1">
            {r.vulns.slice(0, 8).map((v) => (
              <span key={v} className="font-mono text-[10px] border border-sev-critical text-sev-critical px-1.5 py-0.5">{v}</span>
            ))}
          </div>
        </div>
      )}
      {r.note && (
        <div className="text-xs text-muted-foreground border border-border p-2 flex items-start gap-2">
          <ShieldCheck className="w-3 h-3 mt-0.5 flex-shrink-0" />
          {r.note}
        </div>
      )}
      {r.error && (
        <div className="text-xs text-sev-critical border border-sev-critical/50 p-2 font-mono">{r.error}</div>
      )}
    </div>
  );
}
